module.exports = __webpack_public_path__ + "img/comprasegura.4aebf4fd.png";